$(function () {

    $(document).ready(function () {

        var heros = $('.owl-carousel-hero');

        if (heros.length > 0) {
            // initialize heros into carousels
            heros.each(function (i, e) {

                $(this).owlCarousel({
                    loop: true,
                    autoplay: true,
                    dots: false,
                    nav: false,
                    navText: ["<i class='fa fa-chevron-left fa-lg'></i>", "<i class='fa fa-chevron-right fa-lg'></i>"],
                    responsive: {
                        0: {
                            items: 1
                        }
                    }
                });
            });
        }
    });
});